var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FSelect',{staticClass:"mb-0",attrs:{"label":_vm.$t('R.LIT_Territory'),"options":_vm.territories},on:{"input":_vm.onInput},model:{value:(_vm.store.territoryId),callback:function ($$v) {_vm.$set(_vm.store, "territoryId", $$v)},expression:"store.territoryId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }